import { useSimulationStore } from '@/store/simulationStore';
import styles from './IOPanel.module.css';

export function IOPanel() {
    const snapshot = useSimulationStore((state) => state.snapshot);
  const setInput = useSimulationStore((state) => state.setInput);
  const engine = useSimulationStore((state) => state.engine);

  // We read directly from the host IO for real-time visualization
  const inputByte = engine.host.physicalInputs[0] ?? 0;
  const outputByte = engine.host.physicalOutputs[0] ?? 0;

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <h4 className={styles.header}>INPUTS</h4>
        <ul className={styles.list}>
          {Array.from({ length: 8 }).map((_, bit) => {
            const isSet = (inputByte & (1 << bit)) !== 0;
            return (
              <li key={`I0.${bit}`} className={styles.listItem}>
                <span className={styles.label}>I0.{bit}</span>
                <button 
                  className={`${styles.button} ${isSet ? styles.on : styles.off}`}
                  onClick={() => setInput(0, bit, !isSet)}
                >
                  {isSet ? 'ON' : 'OFF'}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={styles.section}>
        <h4 className={styles.header}>OUTPUTS</h4>
        <ul className={styles.list}>
          {Array.from({ length: 8 }).map((_, bit) => {
            const isSet = (outputByte & (1 << bit)) !== 0;
            return (
              <li key={`Q0.${bit}`} className={styles.listItem}>
                <span className={styles.label}>Q0.{bit}</span>
                <span className={`${styles.indicator} ${isSet ? styles.on : styles.off}`}>
                  {isSet ? 'ON' : 'OFF'}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={styles.section}>
        <h4 className={styles.header}>SIMULATION</h4>
        <div className={styles.stats}>
          <div>Status: {snapshot.state}</div>
          <div>Cycle: {snapshot.cycle}</div>
          <div>Scan Time: {snapshot.scanTimeMs.toFixed(2)} ms</div>
          <div>Sim Time: {(snapshot.simulationTimeMs / 1000).toFixed(2)} s</div>
        </div>
      </div>
    </div>
  );
}
